let Backbone = require("backbone");
let MenuItemCollection = require("../collection/MenuItemCollection.js");

let main = function (Backbone, MenuItemCollection) {
    return Backbone.Model.extend({
        'default': {
            menuItems: null,
            tags: null
        },

        getMenuItems: function () {
            return this.get("menuItems");
        },

        setMenuItems: function (menuItems) {
            this.set("menuItems", menuItems);
        },

        getTags: function () {
            return this.get("tags");
        },

        setTags: function (tags) {
            this.set("tags", tags);
        }
    });

};

let exportedValue = main(Backbone, MenuItemCollection);
export default exportedValue;


// WEBPACK FOOTER //
// ./src/model/MenuCategoryModel.js